<template>
  <div class="yhc-estimate-form-page-header">
    <div class="yhc-estimate-form-page-header--logo-area">
      <div class="yhc-estimate-form-page-header--logo">
        <a
          href="https://www.008008.jp/"
          target="_blank"
          rel="noopener"
          ><img src="/images/yhc-logo.jpg"
        /></a>
      </div>
      <div
        v-if="isStaging"
        style="color: red; font-size: 24px; font-weight: bold"
      >
        ※テスト環境です※
      </div>
    </div>
    <div class="text-center bold header-title pt-1">料金・日時 シミュレーション</div>
    <div class="yhc-estimate-form-page-header--description pt-2">
      家財おまかせ便は、お荷物のサイズ（高さ＋幅＋奥行の3辺計）とお届け先の都道府県に応じた料金体系です。<br />
      シミュレーションで表示される料金は概算となります。実際の料金はサービスご利用時に弊社社員がお荷物の3辺を採寸し、確定します。
    </div>
    <div class="yhc-estimate-form-page-header--old-simulation-link pt-3">
      ※お預かり先、お届け先地域を選択し、サイズごとの輸送料金を簡易検索したい場合は<a
        :href="oldSimulationLinkPath"
        target="_blank"
        rel="noopener"
        @click="handleLinkClick"
        >こちら</a
      >をご利用ください。
    </div>
  </div>
</template>
<script lang="ts">
import { $yhcGA4EventSender } from '../YhcGA4EventSender'

const oldSimulationLink = {
  pc: 'https://form.008008.jp/mitumori/PKZI1100Action_doInit.action',
  sp: 'https://form.008008.jp/mitumori/SKZI1100Action_doInit.action',
}
export default {
  name: 'YhcEFPageHeader',
  computed: {
    isStaging() {
      return (
        process.env.NODE_ENV === 'staging' && process.env.LOAD_STAGE_ENV === 'staging'
      )
    },
    oldSimulationLinkPath() {
      return this.isMobile ? oldSimulationLink.sp : oldSimulationLink.pc
    },
  },
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    this.checkDeviceScreenSize()
  },
  methods: {
    // デバイスのスクリーンサイズをチェック
    checkDeviceScreenSize() {
      const width = window.innerWidth
      if (width < 768) {
        this.$nextTick(() => {
          this.isMobile = true
        })
      }
    },
    handleLinkClick() {
      // GA4へイベント送信
      $yhcGA4EventSender.moveOldSearchPage()
    },
  },
}
</script>

<style lang="scss">
.yhc-estimate-form-page-header {
  padding: var(--yhc-base-pad);

  .header-title {
    color: var(--yhc-color);
    font-size: 38px;
    line-height: 1.5;
    font-family: 'Meiryo UI', sans-serif;

    @media screen and (max-width: 757px) {
      font-size: 25px;
    }
  }

  .yhc-estimate-form-page-header--logo-area {
    display: flex;
    justify-content: space-between;

    .yhc-estimate-form-page-header--logo {
      width: 40%;
      max-width: 280px;
      min-width: 100px;

      img {
        width: 100%;
      }
    }
  }

  .yhc-estimate-form-page-header--description {
    font-size: 14px;
    text-align: center;

    @media screen and (max-width: 757px) {
      font-size: 12px;
    }
  }

  .yhc-estimate-form-page-header--old-simulation-link {
    font-size: 16px;
    text-align: center;
    font-weight: bold;

    a {
      color: var(--yhc-color);
      text-decoration: underline;
    }

    @media screen and (max-width: 757px) {
      font-size: 13px;
    }
  }
}
</style>
